/* Shop the look panel - shared by sections/cl-collection-tiles.liquid (image grid tiles)
   and sections/cl-look-split.liquid (homepage split). Panel markup comes from
   snippets/cl-look-panel.liquid; any element with data-cl-look="<panel id>" opens it.
   Delegated on document and bound once, because collection tiles are clones that Globo
   re-inserts, and both sections may load this file. */
(function () {
  if (!window.clLookBound) {
    window.clLookBound = true;

    var openPanel = null;
    var trigger = null;
    var savedY = 0;
    var EASE_MS = 450;

    function lock() {
      savedY = window.scrollY;
      var bar = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.top = -savedY + 'px';
      if (bar > 0) document.body.style.paddingRight = bar + 'px';
      document.body.classList.add('cl-look-locked');
    }
    function unlock() {
      document.body.classList.remove('cl-look-locked');
      document.body.style.top = '';
      document.body.style.paddingRight = '';
      window.scrollTo(0, savedY);
    }

    function open(id, from) {
      var el = document.getElementById(id);
      if (!el) return;
      // Re-parent to <body> once, so no transformed ancestor can trap position: fixed.
      if (el.parentNode !== document.body) document.body.appendChild(el);
      trigger = from || null;
      el.hidden = false;
      lock();
      el.offsetWidth; // commit the hidden -> visible change before animating in
      el.classList.add('is-open');
      openPanel = el;
      updateTotal(el);
      var panel = el.querySelector('.cl-look__panel');
      setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    }

    function close(then) {
      var el = openPanel;
      if (!el) { if (then) then(); return; }
      openPanel = null;
      el.classList.remove('is-open');
      setTimeout(function () {
        el.hidden = true;
        unlock();
        if (then) then();
        else if (trigger) trigger.focus({ preventScroll: true });
      }, EASE_MS);
    }

    function sectionInner(html, selector) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector(selector);
      return node ? node.innerHTML : '';
    }

    // Mirrors the theme's own quick-add (app.min.js renderContents): swap in the fresh
    // cart-drawer and cart-bubble sections and re-init CartDrawer. Returns the new item count.
    function refreshCart(sections) {
      var drawer = document.getElementById('Cart-Drawer');
      var toggle = document.getElementById('cart-drawer-toggle');
      if (!sections) return null;
      if (drawer && sections['cart-drawer']) drawer.innerHTML = sectionInner(sections['cart-drawer'], '.cart-drawer');
      var bubble = toggle && toggle.querySelector('.float_count');
      if (bubble && sections['cart-bubble']) bubble.innerHTML = sectionInner(sections['cart-bubble'], '.float_count');
      if (drawer && typeof CartDrawer !== 'undefined') new CartDrawer();
      return bubble ? bubble.textContent.trim() : null;
    }

    function openCart() {
      var toggle = document.getElementById('cart-drawer-toggle');
      if (!document.getElementById('Cart-Drawer') || !toggle) {
        window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
        return;
      }
      setTimeout(function () { toggle.click(); }, 100);
    }

    function qtyOf(item) {
      var input = item.querySelector('.cl-look__qty-input');
      var q = parseInt(input && input.value, 10);
      var min = Math.max(1, +input.min || 1); // Shopify quantity rule (2 for wholesale)
      return q >= min ? Math.min(q, 99) : min;
    }

    // Keeps the "Add the full look" price in step with the chosen quantities, and shows the
    // free-shipping line while that total reaches the free-shipping minimum.
    function updateTotal(panel) {
      var all = panel.querySelector('[data-cl-look-all]');
      if (!all) return;
      var cents = 0;
      panel.querySelectorAll('.cl-look__item').forEach(function (item) {
        cents += (+item.dataset.price || 0) * qtyOf(item);
      });
      if (typeof formatMoney === 'function') {
        all.querySelector('.cl-look__all-price').textContent = formatMoney(cents, all.dataset.moneyFormat);
      }
      var perk = all.querySelector('.cl-look__all-perk');
      var min = +all.dataset.freeMin || 0;
      if (perk && min) {
        // The minimum is in the shop currency; prices are in the visitor's currency.
        var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        var on = cents >= min * rate;
        perk.hidden = !on;
        all.classList.toggle('has-perk', on);
      }
    }

    // ---- Tracking (approved by the client 2026-10-11) -------------------------------------
    // Events go out through Shopify's customer-events API (Shopify.analytics.publish). They do
    // nothing on their own: the custom pixel "CL - Shop the look" (Settings > Customer events)
    // subscribes to them and forwards them to Google Analytics, and it only runs with the
    // visitor's analytics consent. Event names: cl_look_viewed (2026-10-16), cl_look_opened,
    // cl_look_product_click, cl_look_added, cl_look_added_all. Money values are in the
    // visitor's currency.
    function track(name, data) {
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, data);
        }
      } catch (e) { /* tracking must never break the panel */ }
    }

    function lookContext(panel) {
      return {
        look: panel.dataset.look || '',
        page_type: panel.dataset.page || '',
        collection: panel.dataset.collection || '',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || ''
      };
    }

    function itemData(item, qty) {
      return {
        product_id: item.dataset.productId || '',
        variant_id: item.dataset.variant || '',
        product_title: item.dataset.title || '',
        price: (+item.dataset.price || 0) / 100,
        quantity: qty
      };
    }

    // ---- Per-image tracking (2026-10-16) -------------------------------------------------
    // position: 1-based place of the image among the looks visible on the page right now.
    // filter:   the Lookbook's active color ('all' or a palette handle), blank elsewhere.
    function placement(opener) {
      var visible = [].filter.call(document.querySelectorAll('[data-cl-look]'), function (o) { return o.offsetParent !== null; });
      var chip = document.querySelector('[data-cl-lb] .cl-lb__chip.is-active');
      return { position: visible.indexOf(opener) + 1, filter: chip ? chip.getAttribute('data-lb-filter') : '' };
    }

    // cl_look_viewed: an image counts as seen once at least half of it has been on screen for
    // a full second, and only once per look per page view (re-showing it after a filter change
    // or a Globo re-render does not count again). Divide opens by views for a click rate.
    var seen = {};
    var timers = new WeakMap();
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var o = en.target;
        if (en.isIntersecting) {
          if (timers.has(o)) return;
          timers.set(o, setTimeout(function () {
            timers.delete(o);
            var panel = document.getElementById(o.getAttribute('data-cl-look'));
            var handle = panel && panel.dataset.look;
            if (!handle || seen[handle] || o.offsetParent === null) return;
            seen[handle] = true;
            track('cl_look_viewed', withContext(panel, placement(o)));
          }, 1000));
        } else if (timers.has(o)) {
          clearTimeout(timers.get(o));
          timers.delete(o);
        }
      });
    }, { threshold: 0.5 }) : null;
    function watchLooks() {
      if (!io) return;
      [].forEach.call(document.querySelectorAll('[data-cl-look]'), function (o) {
        if (o.clLookWatched) return;
        o.clLookWatched = true;
        io.observe(o);
      });
    }
    // Collection tiles are clones Globo inserts after load and again on every re-render.
    var watchQueued = false;
    new MutationObserver(function () {
      if (watchQueued) return;
      watchQueued = true;
      setTimeout(function () { watchQueued = false; watchLooks(); }, 300);
    }).observe(document.documentElement, { childList: true, subtree: true });
    watchLooks();

    // Assisted attribution: every look opened is added to the hidden cart attribute
    // _looks_opened (comma list of look handles, newest last, max 15). Cart attributes travel
    // onto the order, so an order shows which images the customer opened even when the
    // cushions were bought from the product page rather than from the panel (that direct path
    // is the _look line property). First-party order data, not sent to any analytics tool.
    function rememberLook(handle) {
      if (!handle) return;
      var key = 'clLooksOpened';
      var mine = [];
      try { mine = JSON.parse(window.sessionStorage.getItem(key) || '[]'); } catch (e) {}
      if (mine.indexOf(handle) > -1) return;
      mine.push(handle);
      try { window.sessionStorage.setItem(key, JSON.stringify(mine.slice(-15))); } catch (e) {}
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = (((cart && cart.attributes) || {})._looks_opened || '').split(',').filter(Boolean);
          if (have.indexOf(handle) > -1) return;
          have.push(handle);
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { _looks_opened: have.slice(-15).join(',') } })
          });
        })
        .catch(function () { /* attribution must never break the panel */ });
    }

    function withContext(panel, extra) {
      var d = lookContext(panel);
      for (var k in extra) d[k] = extra[k];
      return d;
    }

    // Every cart line added from a panel carries the hidden property _look, so orders show
    // which look sold what. Properties starting with "_" are hidden from the customer in the
    // cart drawer, cart page and checkout.
    function lineItems(panel, items) {
      var look = panel.dataset.look;
      return items.map(function (it) {
        return look ? { id: it.id, quantity: it.quantity, properties: { _look: look } } : it;
      });
    }

    function post(items) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); });
    }

    function busy(btn, on, text) {
      if (on) {
        btn.dataset.label = btn.innerHTML;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-loading');
        if (text) btn.textContent = text;
      } else {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      }
    }

    function showViewCart(panel, count) {
      var vc = panel.querySelector('[data-cl-look-viewcart]');
      if (!vc) return;
      vc.querySelector('.cl-look__viewcart-count').textContent = count ? '(' + count + ')' : '';
      vc.hidden = false;
    }

    // One product: the panel stays open so the rest of the look can be added too.
    function addOne(btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var panel = btn.closest('.cl-look');
      var item = btn.closest('.cl-look__item');
      var err = item.querySelector('.cl-look__error');
      err.hidden = true;
      busy(btn, true, (window.theme && theme.strings && theme.strings.addingToCart) || '...');
      var qty = qtyOf(item);
      post(lineItems(panel, [{ id: +item.dataset.variant, quantity: qty }]))
        .then(function (res) {
          if (res.status) {
            btn.innerHTML = btn.dataset.label;
            err.textContent = res.description || res.message || '';
            err.hidden = false;
            return;
          }
          var d = itemData(item, qty);
          track('cl_look_added', withContext(panel, { item: d, value: d.price * qty }));
          showViewCart(panel, refreshCart(res.sections));
          btn.classList.add('is-added');
          btn.textContent = panel.dataset.addedLabel || 'Added';
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.innerHTML = btn.dataset.label;
          }, 2200);
        })
        .catch(function (e) { console.error(e); btn.innerHTML = btn.dataset.label; })
        .finally(function () { busy(btn, false); });
    }

    // The whole look at the chosen quantities, then on to the cart.
    function addAll(btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var panel = btn.closest('.cl-look');
      var items = [];
      var tracked = [];
      var value = 0;
      panel.querySelectorAll('.cl-look__item').forEach(function (item) {
        var q = qtyOf(item);
        items.push({ id: +item.dataset.variant, quantity: q });
        var d = itemData(item, q);
        tracked.push(d);
        value += d.price * q;
      });
      busy(btn, true);
      post(lineItems(panel, items))
        .then(function (res) {
          btn.innerHTML = btn.dataset.label;
          if (res.status) {
            var err = panel.querySelector('.cl-look__error');
            if (err) { err.textContent = res.description || res.message || ''; err.hidden = false; }
            return;
          }
          track('cl_look_added_all', withContext(panel, { items: tracked, value: value }));
          refreshCart(res.sections);
          close(openCart);
        })
        .catch(function (e) { console.error(e); btn.innerHTML = btn.dataset.label; })
        .finally(function () { busy(btn, false); });
    }

    function stepQty(btn) {
      var wrap = btn.closest('.cl-look__qty');
      var input = wrap.querySelector('.cl-look__qty-input');
      var min = Math.max(1, +input.min || 1);
      input.value = Math.max(min, Math.min(99, (parseInt(input.value, 10) || min) + (+btn.dataset.clQtyStep)));
      syncQty(input);
    }

    function syncQty(input) {
      var wrap = input.closest('.cl-look__qty');
      var min = Math.max(1, +input.min || 1);
      var q = parseInt(input.value, 10) || min;
      wrap.querySelector('[data-cl-qty-step="-1"]').disabled = q <= min;
      wrap.querySelector('[data-cl-qty-step="1"]').disabled = q >= 99;
      updateTotal(input.closest('.cl-look'));
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cl-look]');
      if (opener) {
        e.preventDefault();
        var target = document.getElementById(opener.getAttribute('data-cl-look'));
        open(opener.getAttribute('data-cl-look'), opener);
        if (target) {
          track('cl_look_opened', withContext(target, placement(opener)));
          rememberLook(target.dataset.look);
        }
        return;
      }
      if (!openPanel) return;
      var t = e.target;
      var prod = t.closest('[data-cl-look-product]');
      if (prod) {
        var pi = prod.closest('.cl-look__item');
        if (pi) track('cl_look_product_click', withContext(openPanel, { item: itemData(pi, qtyOf(pi)) }));
        return; // let the link navigate
      }
      if (t.closest('[data-cl-look-close]')) { close(); return; }
      if (t.closest('[data-cl-look-viewcart]')) { close(openCart); return; }
      var step = t.closest('[data-cl-qty-step]');
      if (step) { stepQty(step); return; }
      var one = t.closest('[data-cl-look-add]');
      if (one) { addOne(one); return; }
      var all = t.closest('[data-cl-look-all]');
      if (all) addAll(all);
    });

    // Typed quantities: clamp on blur/enter, and keep the total current while typing.
    document.addEventListener('input', function (e) {
      if (e.target.classList && e.target.classList.contains('cl-look__qty-input')) updateTotal(e.target.closest('.cl-look'));
    });
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('cl-look__qty-input')) return;
      input.value = Math.max(1, Math.min(99, parseInt(input.value, 10) || 1));
      syncQty(input);
    });

    document.addEventListener('keydown', function (e) {
      if (!openPanel) return;
      if (e.key === 'Escape') { close(); return; }
      // Keep Tab inside the panel while it is open.
      if (e.key !== 'Tab') return;
      var f = openPanel.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
})();
